(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
  const formatMoney = cents => {
    try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: window.PW3?.currency || 'TRY' }).format((Number(cents) || 0) / 100); }
    catch { return `${((Number(cents) || 0) / 100).toFixed(2)} ${window.PW3?.currency || 'TRY'}`; }
  };
  const toast = message => {
    const node = $('[data-pw3-toast]');
    if (!node) return;
    node.textContent = message;
    node.classList.add('is-visible');
    window.clearTimeout(node._pw5Timer);
    node._pw5Timer = window.setTimeout(() => node.classList.remove('is-visible'), 2300);
  };
  const cartLineMarkup = item => {
    const imageUrl = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=240` : '';
    const image = imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="" loading="lazy">` : '';
    const title = escapeHtml((item.product_title || '').split('|')[0].trim());
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHtml(item.variant_title)}</small>` : '';
    return `<article class="pw3-cart-line" data-pw3-cart-line data-key="${escapeHtml(item.key)}"><a href="${escapeHtml(item.url)}" class="pw3-cart-line__image">${image}</a><div class="pw3-cart-line__info"><a href="${escapeHtml(item.url)}">${title}</a>${variant}<div class="pw3-qty"><button type="button" data-pw3-qty="minus" aria-label="Azalt">−</button><span>${item.quantity}</span><button type="button" data-pw3-qty="plus" aria-label="Artır">+</button></div><button type="button" class="pw3-cart-line__remove" data-pw3-remove>KALDIR</button></div><strong>${formatMoney(item.final_line_price)}</strong></article>`;
  };
  const refreshCart = async () => {
    const response = await fetch(`${window.PW3?.cart || '/cart'}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart-refresh');
    const cart = await response.json();
    $$('[data-pw3-cart-count],[data-pw3-cart-heading-count]').forEach(node => { node.textContent = String(cart.item_count); });
    $$('[data-pw3-cart-total]').forEach(node => { node.textContent = formatMoney(cart.total_price); });
    $$('[data-pw3-checkout]').forEach(node => { node.disabled = cart.item_count === 0; });
    const threshold = Number(window.PW3?.freeShippingThreshold || 100000);
    const remaining = Math.max(0, threshold - cart.total_price);
    const progress = Math.min(100, cart.total_price / threshold * 100);
    $$('[data-pw3-shipping-progress]').forEach(node => { node.style.width = `${progress}%`; });
    $$('[data-pw3-shipping-copy]').forEach(node => { node.textContent = remaining <= 0 ? 'ÜCRETSİZ KARGO AÇILDI' : 'ÜCRETSİZ KARGOYA YAKLAŞIYORSUN'; });
    $$('[data-pw3-shipping-value]').forEach(node => { node.textContent = remaining <= 0 ? '' : `${formatMoney(remaining)} KALDI`; });
    const body = $('[data-pw3-cart-body]');
    if (body) body.innerHTML = cart.items.length ? cart.items.map(cartLineMarkup).join('') : '<div class="pw3-cart__empty"><div><p>Sepetin şu anda boş.</p><a href="/collections/all">ALIŞVERİŞE BAŞLA</a></div></div>';
    return cart;
  };
  const openCart = () => $('[data-pw3-open="cart"]')?.click();
  const initRails = root => {
    $$('[data-pw5-bestsellers]', root).forEach(section => {
      if (section.dataset.pw5Ready === 'true') return;
      section.dataset.pw5Ready = 'true';
      const rail = $('[data-pw5-rail]', section);
      const prev = $('[data-pw5-rail-prev]', section);
      const next = $('[data-pw5-rail-next]', section);
      if (!rail) return;
      const distance = () => Math.max(280, rail.clientWidth * .72);
      const update = () => {
        if (prev) prev.disabled = rail.scrollLeft <= 4;
        if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      };
      prev?.addEventListener('click', () => rail.scrollBy({ left: -distance(), behavior: 'smooth' }));
      next?.addEventListener('click', () => rail.scrollBy({ left: distance(), behavior: 'smooth' }));
      rail.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(rail);
      update();
    });
  };
  const addSet = async button => {
    const ids = [button.dataset.variantOne, button.dataset.variantTwo, button.dataset.variantThree].filter(Boolean);
    if (!ids.length || button.disabled) return;
    const original = button.innerHTML;
    button.disabled = true;
    button.textContent = 'RİTÜEL EKLENİYOR…';
    try {
      const response = await fetch(`${window.PW3?.cartAdd || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map(id => ({ id: Number(id), quantity: 1 })) })
      });
      if (!response.ok) throw new Error('set-add');
      await refreshCart();
      toast('RİTÜEL SEPETİNE EKLENDİ');
      window.setTimeout(openCart, 90);
    } catch {
      toast('RİTÜEL EKLENEMEDİ. LÜTFEN TEKRAR DENE.');
    } finally {
      button.disabled = false;
      button.innerHTML = original;
    }
  };
  const initMedia = root => {
    $$('[data-section-id] video', root).forEach(video => {
      if (video.dataset.pw5Observed === 'true') return;
      video.dataset.pw5Observed = 'true';
      video.muted = true;
      video.playsInline = true;
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) video.play().catch(() => {});
        else video.pause();
      }), { threshold: .25 }).observe(video);
    });
  };
  const init = root => {
    initRails(root);
    initMedia(root);
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-pw5-set-add]');
    if (!button) return;
    event.preventDefault();
    addSet(button);
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
